import React from 'react';
import { Router, Route, browserHistory } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import SalePage from '../components/SalePage';
//import SearchKeyword from '../components/SearchKeyword';

function RouterConfig(props) {
  return (
    <Router history={props.history}>
      <LocaleProvider locale={ja_JP}>
        {/*   <Route path="/travel" component={SalePage} /> */}
        <Route path="/travel" render={() => <SalePage appKey={props.app.appkey} />} />
      </LocaleProvider>
    </Router>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/travel/config/router.js